import { useMutation } from '@tanstack/react-query';
import useGetMutationFn from '../use-get-mutation-fn';

type MutationPayload = {
  to: string;
  type: string;
  body: string;
}
type MutationResponse = {
  timestamp: string,
  statusCode: number,
  status: string,
  message: string,
  data: any
};

export const useSendWhatsappTemplateMutation = () => {
  const mutationFn = useGetMutationFn<MutationPayload, MutationResponse>({
    defaultErrorMessage: 'An unexpected error occurred while sending WhatsApp Template',
    endpoint: '/api/admin/whatsapp/send-template',
    method: 'POST',
  });

  return useMutation<MutationResponse, Error, MutationPayload>({ mutationFn });
};

export const useDeleteTemplateMutation = () => {
  const mutationFn = useGetMutationFn<{id: string}, MutationResponse>({
    defaultErrorMessage: 'An unexpected error occurred during WhatsApp broadcast',
    endpoint: ({id}) => `/api/admin/whatsapp/template/${id}`,
    method: 'DELETE',
  });

  return useMutation<MutationResponse, Error, {id: string}>({ mutationFn });
};